// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"BusinessInfoPage_PageHeader__32rCw","Card":"BusinessInfoPage_Card__2cXRn"};